<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
            <Form @submit="EditValidationQueue">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Code <span class="text-danger">*</span>
                            </label>
                            <Field name="code" type="text" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrez le code " v-model="formData.code" />
                            <ErrorMessage name="code" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Libellé de la file <span class="text-danger">*</span>
                            </label>
                            <Field name="name" type="text" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="" v-model="formData.name" />
                            <ErrorMessage name="name" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Description <span class="text-danger">*</span>
                            </label>
                            <Field name="description" as="textarea" class="form-control shadow-none fs-md-15 text-black"
                                v-model="formData.description" />
                            <ErrorMessage name="description" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Niveau de risque minimal des dossiers acceptés <span class="text-danger">*</span>
                            </label>
                            <Multiselect :options="minRiskOptions" :searchable="true" :multiple="false"
                                value-prop="value" track-by="value" :object="true" label="label"
                                v-model="formData.minRiskLevel" placeholder="Sélectionner le niveau de risque" />
                            <ErrorMessage name="minRiskLevel" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Niveau de risque maximal des dossiers acceptés <span class="text-danger">*</span>
                            </label>
                            <Multiselect :options="maxRiskOptions" :searchable="true" :multiple="false"
                                value-prop="value" track-by="value" :object="true" label="label"
                                v-model="formData.maxRiskLevel" placeholder="Sélectionner le niveau de risque" />
                            <ErrorMessage name="maxRiskLevel" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Port <span class="text-danger">*</span>
                            </label>
                            <Multiselect v-model="formData.port" :options="portOptions" :searchable="true"
                                :multiple="false" value-prop="value" :object="true" track-by="value" label="label"
                                placeholder="Sélectionner le port" />
                            <ErrorMessage name="port" class="text-danger" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Pays <span class="text-danger">*</span>
                            </label>
                            <Multiselect v-model="formData.pays" :options="paysOptions" :searchable="true"
                                :multiple="false" value-prop="value" :object="true" track-by="value" label="label"
                                placeholder="Sélectionner le pays" />
                            <ErrorMessage name="pays" class="text-danger" />
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="d-flex align-items-center ">
                            <button
                                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                                type="submit">
                                Modifier
                            </button>
                            <router-link to="/listevalidationqueue"
                                class=" btn btn-danger transition border-0 lh-1 fw-medium"><i
                                    class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                                <span class="position-relative"></span>Annuler</router-link>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, onMounted, nextTick } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { useRoute, useRouter } from "vue-router";
import Multiselect from '@vueform/multiselect'
import ApiService from "../../services/ApiService";
import { error, success } from "../../utils/utils";
import { ValidationQueues } from "@/models/ValidationTask";

export default defineComponent({
    name: "EditValidationQueue",
    components: { Form, Field, ErrorMessage, Multiselect },
    setup() {
        const router = useRouter();
        const route = useRoute();
        const queueId = route.params.id;
        const EditQueueSchema = Yup.object().shape({
            // code: Yup.string().required('Le code est obligatoire'),
            // name: Yup.string().required('Le champ name est obligatoire'),
            // description: Yup.string().required('Ce champ est obligatoire'),
            // min_risk_level: Yup.string().required('Ce champ est obligatoire'),
        });

        interface Option {
            value: number | string;
            label: string;
        }

        // Pour ports et pays
        const portOptions = ref<Option[]>([]);
        const paysOptions = ref<Option[]>([]);

        const maxRiskOptions = [
            { value: 'LOW', label: 'Faible' },
            { value: 'MEDIUM', label: 'Moyen' },
            { value: 'HIGH', label: 'Elévé' },
        ]
        const minRiskOptions = [
            { value: 'LOW', label: 'Faible' },
            { value: 'MEDIUM', label: 'Moyen' },
            { value: 'HIGH', label: 'Elévé' },
        ]



        const fetchPays = async () => {
            try {
                const response = await ApiService.get('/pays?limit=0');
                const paysData = response.data.data.data;
                paysOptions.value = paysData.map((pays) => ({
                    value: pays.id,
                    label: `${pays.iso2_code} ${pays.iso3_code} ${pays.name_fr} ${pays.name_en}`
                }))
            } catch (error) {
                //
            }
        }

        const fetchPort = async () => {
            try {
                const response = await ApiService.get('/ports?limit=0');
                const portData = response.data.data.data;
                portOptions.value = portData.map((port) => ({
                    value: port.id,
                    label: `${port.nomPort}`
                }))
            } catch (error) {
                //
            }
        }
        interface ValidationQueuesForm {
            code: string;
            name: string;
            description: string;
            minRiskLevel: { value: string, label: string } | null;
            maxRiskLevel: { value: string, label: string } | null;
            port: { value: number, label: string } | null;
            pays: { value: number, label: string } | null;
        }


        // FORM DATA
        const formData = reactive<ValidationQueuesForm>({
            code: "",
            name: "",
            description: "",
            minRiskLevel: null,
            maxRiskLevel: null,
            port: null,
            pays: null,


        });

        const getValidationQueue = async (id: string) => {
            try {
                const response = await ApiService.get(`/validationq/${id}`);
                const queue = response.data.data;

                formData.code = queue.code;
                formData.name = queue.name;
                formData.description = queue.description;

                // Risques : find garde la référence exacte (mieux pour les options statiques)
                formData.minRiskLevel = minRiskOptions.find(opt => opt.value === queue.minRiskLevel) || null;
                formData.maxRiskLevel = maxRiskOptions.find(opt => opt.value === queue.maxRiskLevel) || null;
                // Port et Pays : création manuelle (avec :object="true", ça affichera le label même si pas dans options encore)
                formData.port = queue.port ? { value: queue.port.id, label: queue.port.nomPort } : null;
                // Adaptez le label pour pays comme dans votre code original
                formData.pays = queue.pays ? {
                    value: queue.pays.id,
                    label: `${queue.pays.iso2_code} ${queue.pays.iso3_code} ${queue.pays.name_fr} ${queue.pays.name_en}`
                } : null;
                await nextTick(); // Toujours bon pour forcer le refresh

            } catch (err: any) {
                error(err.response?.data?.message || "Erreur lors du chargement");
            }
        };
        // MODIFIER
        const EditValidationQueue = async () => {
            try {
                const payload = {
                    code: formData.code,
                    name: formData.name,
                    description: formData.description,
                    minRiskLevel: formData.minRiskLevel?.value,
                    maxRiskLevel: formData.maxRiskLevel?.value,
                    port: formData.port?.value,         
                    pays: formData.pays?.value,        
                };
                console.log("Payload FINAL :", payload);

                await ApiService.put(`/validationq/${queueId}`, payload);
                success("Modification réussie !");
                router.push("/listevalidationqueue");
            } catch (err: any) {
                error(err.response?.data?.message || "Échec de la modification");
            }
        };

        onMounted(async () => {
            await fetchPays();
            await fetchPort();
            await getValidationQueue(queueId as string);
        });



        return {
            formData,
            EditQueueSchema,
            EditValidationQueue,
            paysOptions,
            portOptions,
            minRiskOptions,
            maxRiskOptions,


        };
    }
});
</script>
